"use client";
import * as React from 'react';
import { CalendarDays } from 'lucide-react';
import { format } from 'date-fns';
import type { DateRange } from 'react-day-picker';
import { Button } from './button';
import { Calendar } from './calendar';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

export interface DatePickerProps {
  date?: Date;
  value?: Date;
  defaultValue?: Date;
  onDateChange?: (date: Date | undefined) => void;
  onValueChange?: (date: Date | undefined) => void;
  onSelect?: (date: Date | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  calendarProps?: Omit<React.ComponentProps<typeof Calendar>, 'mode' | 'selected' | 'onSelect'>;
}
export function DatePicker({date,value,defaultValue,onDateChange,onValueChange,onSelect,placeholder='Pick a date',disabled,className,calendarProps}:DatePickerProps){
  const [local,setLocal]=React.useState(defaultValue);
  const [open,setOpen]=React.useState(false);
  const selected=value??date??local;
  return <Popover open={open} onOpenChange={setOpen}><PopoverTrigger asChild><Button variant="outline" disabled={disabled} className={className}><CalendarDays size={14}/>{selected?format(selected,'MMM d, yyyy'):placeholder}</Button></PopoverTrigger><PopoverContent className="w-auto p-0" align="start"><Calendar mode="single" selected={selected} onSelect={d=>{if(value===undefined&&date===undefined)setLocal(d);onDateChange?.(d);onValueChange?.(d);onSelect?.(d);setOpen(false);}} {...calendarProps}/></PopoverContent></Popover>;
}
export function DateRangePicker({value,onValueChange,disabled,className}:{value?:DateRange;onValueChange?:(range:DateRange|undefined)=>void;disabled?:boolean;className?:string}){
  const [local,setLocal]=React.useState<DateRange>();
  const selected=value??local;
  return <Popover><PopoverTrigger asChild><Button disabled={disabled} variant="outline" className={className}><CalendarDays size={14}/>{selected?.from?`${format(selected.from,'MMM d')}${selected.to?' – '+format(selected.to,'MMM d'):''}`:'Date range'}</Button></PopoverTrigger><PopoverContent className="w-auto p-0"><Calendar mode="range" selected={selected} onSelect={v=>{if(value===undefined)setLocal(v);onValueChange?.(v);}} numberOfMonths={2}/></PopoverContent></Popover>;
}
